import { Component, EventEmitter, Output } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { GeneralService } from 'src/app/api/config/general.service';
import { ServicehotelService } from 'src/app/api/config/servicehotel.service';
import { HotelService } from 'src/app/api/tourism/hotel.service';
import { TourService } from 'src/app/api/tourism/tour.service';
import { ToolsService } from 'src/app/utils/tools.service';
import AlertifyHelper from 'src/app/utils/utils';
declare var $: any;

@Component({
  selector: 'app-video-tourism',
  templateUrl: './video-tourism.component.html',
  styleUrls: ['./video-tourism.component.css']
})
export class VideoTourismComponent {
  @Output() onselectedVideoTourismEvent = new EventEmitter<string>();


  videos: any = [];
  arr_checkeds: any = [];
  

  constructor(
    private generalService: GeneralService,
    private alertifyMsg: AlertifyHelper,
    private toolsService: ToolsService
  ) {}

  

  loadData() {
    this.generalService.listVideosTourism().subscribe({
      next: (data: any) => {
        for (let i in data) {
          data[i].checked = false;
          data[i].is_generate_iframe = true;
        }
        this.videos = data;
      }
    });
  }


  changeChecked() {
    this.arr_checkeds = [];
    for (let i in this.videos) {
      if (this.videos[i].checked == true) {
        if( this.toolsService.notExistObjInArr(this.videos[i], this.arr_checkeds)){
          this.arr_checkeds.push(this.videos[i]);
        }
      }
    }
  }


  addSelecteds() {
    if (this.arr_checkeds.length > 0) {
      this.onselectedVideoTourismEvent.emit(this.arr_checkeds);
      this.close();
      (<any>$('#openExtendsVideoTourism')).modal('hide');
    } else {
      this.alertifyMsg.warning('Debe seleccionar almenos un video');
    }
  }

  resetForm() {
    
  }

  close() {
    this.resetForm();
  }
}
